import { Badge } from "@/components/ui/badge";
import { QualityTier, QUALITY_LABELS } from "@/types";
import { cn } from "@/lib/utils";

const tierColors: Record<QualityTier, string> = {
  unrestricted: "bg-quality-unrestricted text-white",
  residential: "bg-quality-residential text-foreground",
  commercial: "bg-quality-commercial text-white",
  industrial: "bg-quality-industrial text-white",
  restricted: "bg-quality-restricted text-white",
};

export function QualityBadge({ tier, className }: { tier: QualityTier; className?: string }) {
  return (
    <Badge className={cn("border-none font-semibold", tierColors[tier], className)}>
      {QUALITY_LABELS[tier]}
    </Badge>
  );
}
